module.exports = __webpack_public_path__ + "static/media/trading.3061e5db.svg";